<template>
  <div class="specialNotes">
    <div class="specialNotesDetails">
      <input id="specialNotes" type="checkbox" />
      <label for="specialNotes" class="specialNotesTitle">
        <tk-svg-icon class="icoDown" icon="down" />
        新型コロナウィルス感染症対策
      </label>
      <ul class="specialNotesList">
        <li
          v-for="(att, idx) in attributes"
          :key="`covid-info-${idx}`"
          class="specialNotesItem"
        >
          {{ att }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { TkSvgIcon } from '@ota-frontend/ui'

export default {
  name: 'TkCovid19Notes',
  components: {
    TkSvgIcon,
  },
  props: {
    attributes: {
      type: Array,
      default() {
        return []
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@ota-frontend/ui/src/scss/components/TkCovid19Notes.scss';
</style>
